import PropTypes from 'prop-types'
import { View } from './View'

/**
 * Appkit4 Switchコンポーネントは
 * <a href="https://appkit.pwc.com/appkit4/content/toggle?version=react" target="_blank">こちら</a>
 */
export const Switch = ({ ...props }) => {
    return <View {...props} />
}

Switch.propTypes = {
    /**
     * デフォルトの選択状態
     */
    defaultChecked: PropTypes.bool,
    /**
     * 選択状態<br>
     * ※ 選択状態をコンポーネント外で制御する場合に設定
     */
    checked: PropTypes.bool,
    /**
     * 右側に表示するテキスト
     */
    label: PropTypes.string,
    /**
     * 選択変更時のハンドラー<br>
     * (checked: boolean, event: React.SyntheticEvent) => void
     */
    onChange: PropTypes.func,
    /**
     * 切り替え可否
     */
    disabled: PropTypes.bool,
    /**
     * 要素のサイズ
     */
    large: PropTypes.bool,
    /**
     * フォントカラー
     */
    fontColor: PropTypes.string,
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}

Switch.defaultProps = {
    large: true,
    defaultChecked: false,
    disabled: false,
    fontColor: 'var(--iba-black)'
}
